// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.speaker-menu-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
}

.speaker-menu {
  position: fixed;
  background-color: white;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  min-width: 200px;
  max-width: 300px;
}

.speaker-menu-title {
  padding: 8px 12px;
  font-weight: bold;
  border-bottom: 1px solid #eee;
  font-size: 12px;
  color: #333;
}

.speaker-menu-search {
  width: 100%;
  padding: 8px 12px;
  border: none;
  border-bottom: 1px solid #eee;
  font-size: 13px;
  box-sizing: border-box;
  outline: none;
}

.speaker-menu-search:focus {
  background-color: #f9f9f9;
  border-bottom-color: #2d6ebe;
}

.speaker-menu-list {
  max-height: 200px;
  overflow-y: auto;
}

.speaker-menu-item {
  padding: 8px 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #333;
  transition: background-color 0.2s;
}

.speaker-menu-item:hover {
  background-color: #f5f5f5;
}

.speaker-menu-item.selected {
  background-color: #e3f2fd;
  color: #1f5fbf;
  font-weight: 500;
}

.speaker-menu-item.highlighted {
  background-color: #f5f5f5;
}

.speaker-name {
  flex: 1 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: left;
}
`, "",{"version":3,"sources":["webpack://./src/applications/appcode/appcomponents/transcript/components/speaker-menu/speaker-menu.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,YAAY;AACd;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,yCAAyC;EACzC,aAAa;EACb,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,6BAA6B;EAC7B,eAAe;EACf,WAAW;AACb;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,6BAA6B;EAC7B,eAAe;EACf,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,WAAW;EACX,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB","sourcesContent":[".speaker-menu-overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  z-index: 999;\r\n}\r\n\r\n.speaker-menu {\r\n  position: fixed;\r\n  background-color: white;\r\n  border: 1px solid #ccc;\r\n  border-radius: 4px;\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\r\n  z-index: 1000;\r\n  min-width: 200px;\r\n  max-width: 300px;\r\n}\r\n\r\n.speaker-menu-title {\r\n  padding: 8px 12px;\r\n  font-weight: bold;\r\n  border-bottom: 1px solid #eee;\r\n  font-size: 12px;\r\n  color: #333;\r\n}\r\n\r\n.speaker-menu-search {\r\n  width: 100%;\r\n  padding: 8px 12px;\r\n  border: none;\r\n  border-bottom: 1px solid #eee;\r\n  font-size: 13px;\r\n  box-sizing: border-box;\r\n  outline: none;\r\n}\r\n\r\n.speaker-menu-search:focus {\r\n  background-color: #f9f9f9;\r\n  border-bottom-color: #2d6ebe;\r\n}\r\n\r\n.speaker-menu-list {\r\n  max-height: 200px;\r\n  overflow-y: auto;\r\n}\r\n\r\n.speaker-menu-item {\r\n  padding: 8px 12px;\r\n  cursor: pointer;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  font-size: 13px;\r\n  color: #333;\r\n  transition: background-color 0.2s;\r\n}\r\n\r\n.speaker-menu-item:hover {\r\n  background-color: #f5f5f5;\r\n}\r\n\r\n.speaker-menu-item.selected {\r\n  background-color: #e3f2fd;\r\n  color: #1f5fbf;\r\n  font-weight: 500;\r\n}\r\n\r\n.speaker-menu-item.highlighted {\r\n  background-color: #f5f5f5;\r\n}\r\n\r\n.speaker-name {\r\n  flex: 1;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n  text-align: left;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
